import { useEffect } from 'react';

import { useTrack } from '../composition/use-track';
import { SlotHost } from './slot-host';

// 홈 — 한 줄 소개 + 플러그인 위젯(연재 중인 작품 목록). 템플릿의 「API 다시 확인」 버튼은 사용자에게 의미가 없어 뺐다
export function HomePage() {
  const track = useTrack();
  // 화면 진입 같은 행동 아닌 이벤트는 track() 으로 직접 남긴다
  useEffect(() => track('home.view'), [track]);
  return (
    <>
      <section className="flex flex-col gap-2 pt-8 pb-4">
        <h1 className="text-title-lg text-balance">AI로 쓴 이야기, 숨기지 말고 연재하세요</h1>
        <p className="text-sm text-text-neutral-subtle">
          작품마다 AI를 얼마나 썼는지 밝히고 올려요. 독자는 그걸 보고 골라 읽어요.
        </p>
      </section>
      <SlotHost slot="home.main" />
    </>
  );
}
